export interface Loader {
  visibility: boolean;
  counter: number;
}

export const initialLoaderState: Loader = {
  visibility: false,
  counter: 0
};
